// Utility to generate default note text for resume revisions
export function getPremiumNoteDefaults(
  meetingViaCalendly,
  revisionNumber,
  coachName,
  candidateName,
  currentResumeReview,
  isFinalRevision,
  t,
) {
  const prefix = candidateName
    ? t('getPremiumNoteDefaults.greeting', { candidateName })
    : ''
  const suffix = coachName
    ? t('getPremiumNoteDefaults.coach_signature', { coachName })
    : ''

  if (isFinalRevision) {
    return prefix + t('getPremiumNoteDefaults.finalRevision') + suffix
  }

  if (
    meetingViaCalendly === undefined &&
    !currentResumeReview?.revisionDeclined
  ) {
    if (currentResumeReview?.meetingViaCalendly === true) {
      return (
        prefix + t('getPremiumNoteDefaults.firstRevision.meetingBased') + suffix
      )
    } else {
      return (
        prefix + t('getPremiumNoteDefaults.firstRevision.platform') + suffix
      )
    }
  } else if (meetingViaCalendly) {
    if (
      revisionNumber == 2 ||
      (revisionNumber == 1 && currentResumeReview?.revisionDeclined)
    ) {
      return (
        prefix +
        t('getPremiumNoteDefaults.secondRevision.meetingBased.declined') +
        suffix
      )
    } else {
      return (
        prefix +
        t('getPremiumNoteDefaults.secondRevision.meetingBased.completed') +
        suffix
      )
    }
  } else {
    if (
      revisionNumber == 2 ||
      (revisionNumber == 1 && currentResumeReview?.revisionDeclined)
    ) {
      return (
        prefix +
        t('getPremiumNoteDefaults.secondRevision.platform.declined') +
        suffix
      )
    } else {
      return (
        prefix +
        t('getPremiumNoteDefaults.secondRevision.platform.completed') +
        suffix
      )
    }
  }
}
